import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FOOTER, MARKETPLACES, PHONE, PHONE_TN } from '../content';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Footer {
  protected readonly columns = FOOTER;
  protected readonly marketplaces = MARKETPLACES;
  protected readonly phone = PHONE;
  protected readonly phoneTn = PHONE_TN;
}
